import { func, number, shape } from "prop-types";

export const getTanStackRowProps = (original = {}) =>
  shape({
    depth: number,
    getIsExpanded: func,
    getToggleExpandedHandler: func,
    original: shape(original),
  });

export const TanStackRowProps = getTanStackRowProps();

export const DROP_POSITIONS = {
  TOP: "top",
  MIDDLE: "middle",
  BOTTOM: "bottom",
  FORBIDDEN: "forbidden",
};
